import { useTranslation } from 'react-i18next';
import { createDateFormatters } from '../utils/dateUtils';

/**
 * Custom hook for date formatting
 * @returns Object with formatDate and formatTime functions
 */
export function useDateFormatters() {
  const { i18n, t } = useTranslation();
  const { formatDate, formatTime } = createDateFormatters(i18n.language);

  const formatLastClick = (date: string | null): string => {
    if (!date) return t('buttons.never');
    const formattedDate = formatDate(date);
    return formattedDate || t('buttons.never');
  };

  return {
    formatDate,
    formatTime,
    formatLastClick
  };
} 